import * as actions from "./actions";
import * as types from "./actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { BookingReducerType } from "./types";

export type BookingActions = ActionType<typeof actions>;

export const initialState: BookingReducerType = {
  error: null,
  bookings: [],
  bookingsFiltered: [],
  isLoading: false,
  selectedBooking: null,
  updatedBooking: null,
  meta: {
    total: 0,
    per_page: 0,
    last_page: 0,
    current_page: 0,
  },
  formExtension: {
    start_time: null,
    end_time: null
  }
};

export const BookingReducer = createReducer<
  BookingReducerType,
  BookingActions
>(initialState)
  // get list of bookings
  .handleAction(actions.getBookingAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.getBookingAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    bookings: action.payload.data,
    meta: action.payload.meta
  }))
  .handleAction(actions.getBookingAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))

  // search booking
  .handleAction(actions.searchBookingAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.searchBookingAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    bookingsFiltered: action.payload.data,
    meta: action.payload.meta
  }))
  .handleAction(actions.searchBookingAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))

  // select single booking
  .handleAction(actions.selectBookingAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    selectedBooking: null,
    redirectQueue: ''
  }))
  .handleAction(actions.selectBookingAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    selectedBooking: action.payload.data,
    updatedBooking: action.payload.data
  }))
  .handleAction(actions.selectBookingAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))

  // updated selected booking
  .handleAction(actions.updateBookingAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.updateBookingAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    selectedBooking: action.payload.data,
    updatedBooking: action.payload.data,
  }))
  .handleAction(actions.updateBookingAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))

  // create new booking
  .handleAction(actions.createBookingAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.createBookingAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
  }))
  .handleAction(actions.createBookingAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  
  // others
  .handleAction(types.SET_BOOKING as any, (state, action) => ({
    ...state,
    error: null,
    updatedBooking: action.payload 
  }))
  .handleAction(types.SET_FORM_EXTENSION as any, (state, action) => ({
    ...state,
    error: null,
    formExtension: action.payload 
  }))
  .handleAction(types.SET_ERROR as any, (state, action) => ({
    ...state,
    error: action.payload.value
  }))
  .handleAction(types.RESET_STATE as any, (state, action) => ({
    ...state,
    error: null,
    selectedBooking: null
  }))
